export default __webpack_public_path__ + "static/media/interswitchLogo.74d54aac.png";